<template>
  <div class="home">
    <div class="header-wrapper">
      <Header class="header" />
    </div>

    <div class="content">
      <OnePage />
      <TowPage />
      <ThreePage />
      <!-- <FourPage /> -->
      <FooterSection />
    </div>
  </div>
</template>

<script>
import Header from "@/components/one/header.vue";
import OnePage from "@/components/giftCard/onePage.vue";
import TowPage from "@/components/giftCard/towPage.vue";
import ThreePage from "@/components/giftCard/ThreePage.vue";
// import FourPage from "@/components/giftCard/FourPage.vue";
import FooterSection from "@/components/layout/FooterSection.vue";

export default {
  name: "HomeView",
  components: {
    Header,
    OnePage,
    TowPage,
    ThreePage,
    // FourPage,
    FooterSection,
  },
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background-color: #fff;

  .header-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 72px;
    background-color: #000;
    z-index: 9999;
    display: flex;
    justify-content: center;
  }

  .content {
    padding-top: 72px;
    width: 100%;
  }
}
</style>
